








































































import {Component, Vue, Watch} from "vue-property-decorator";
import {ComplaintParams} from "@/modules/complaint/params";
import {ComplaintStatus} from "@/enums/status";
import {ComplaintStore} from "@/modules/complaint/store";
import debounce from "lodash/debounce";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {allComplaint} from "@/modules/complaint/services";
import {UserType} from "@/enums/type/user";
import ComplaintExcel from "@/modules/complaint/List/components/Excel.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
  name: "ComplaintSearch",
  components: {ComplaintExcel, EmployeeSelector, EnumSelector, CustomerSelector, MillisecondDatePicker}
})
export default class extends Vue {
  form = new ComplaintParams()
  ComplaintStatus = ComplaintStatus;
  EmployeeType = EmployeeType;
  UserType = UserType;
  userType = UserType.Customer;
  isExporting = false;
  dataSourceExcel = [] as any;

  onValuesChange() {
        ComplaintStore.updateComplaintParams(this.form);
        ComplaintStore.listComplaint({...this.form, page: 1});
  }

  // @Watch('form', {immediate: false, deep: true})
  // onValueChange(val: any) {
  //     this.handleChange(val);
  // }
  //
  // handleChange = debounce(function (val) {
  //     ComplaintStore.updateComplaintParams(val);
  //     ComplaintStore.listComplaint({...val, page: 1});
  // }, 500)

  onchangeCreatedBy() {
    if (this.form.createdByRowGuid)
      this.form.createdByRowGuid = undefined;
  }


  async exportExcel() {
    try {
      this.dataSourceExcel = await this.getAllDataExport();
      setTimeout(() => {
        TableToExcel.convert(document.getElementById("table-excel-complaint"), {
          name: `Khiếu nại.xlsx`,
          sheet: {
            name: "Sheet 1"
          }
        });
      }, 200)
    } catch (e) {
    }
  }

  async getAllDataExport() {
    try {
      this.isExporting = true;
      const {data} = await allComplaint(ComplaintStore.params);
      return data.datas;
    } catch (e) {
    } finally {
      this.isExporting = false;
    }
  }
}
